import { GROUP_BY_TO_FIELD_MAP } from '../constants';
import { isGridApiValid } from './isGridApiValid';

export const updateGrouping = (api, groupByValue) => {
  if (!isGridApiValid(api)) return;

  if (!groupByValue) {
    const currentRowGroupColumns = api.getRowGroupColumns();
    if (currentRowGroupColumns.length > 0) {
      api.removeRowGroupColumns(currentRowGroupColumns);
    }
    return;
  }

  const fieldName = GROUP_BY_TO_FIELD_MAP[groupByValue];
  if (fieldName) {
    const column = api.getColumn(fieldName);
    if (!column) return;

    const currentRowGroupColumns = api.getRowGroupColumns();
    const currentField = currentRowGroupColumns?.[0]?.getColId();

    if (currentField !== fieldName) {
      if (currentRowGroupColumns.length > 0) {
        api.removeRowGroupColumns(currentRowGroupColumns);
      }
      api.setRowGroupColumns([fieldName]);
    }
  }
};
